<template>
  <div class="select-box-box">
    <div class="select-box" @click="clickSelectBox">
      <div class="input-box">
        <div class="select-box-input d-inline-block">
          <span v-if="!selectedAlready" class="d-text-ligtergrey">{{placeholder}}</span>
          <span v-if="selectedAlready" class="d-text-black">{{selectedAlready}}</span>
        </div>
        <div class="img-box d-border-left d-inline-block d-vertical-center-box">
          <div :class="['sprite', 'sprite-arrow-up', {'arrow-down': !selectOpen}]"></div>
        </div>
      </div>
    </div>
    <div v-show="selectOpen" class="drop-down-box" :style="{'max-height': idealHeight+'px'}">
      <div v-if="!showLoading">
        <div
          v-for="(item) in dataArr"
          :class="['item-row-box', {'touched-bg':item.touched}]"
          @click="touchendItem($event, item)"
          @touchstart="touchstartItem($event, item)"
          @touchmove="touchmoveItem($event, item)"
          @touchend="touchendItem($event, item)"
        >
          <p class="item-row">{{item[displayValue]}}</p>
        </div>
      </div>
      <div class="d-text-small d-text-grey">
        <div class="pageContainer">
          <ul class="pagesInner">
            <li class="page" @click="prevOrNext(-1)">
              <span class="fa fa-chevron-left" aria-hidden="false"><</span>
            </li>
            <li
              class="page"
              v-for="(item, index) in pages"
              :key="index"
              :class="{actived: item === currentPage}"
              @click="select($event,item)"
            >
              <span>{{item}}</span>
            </li>
            <li class="page" @click="prevOrNext(1)">
              <span class="fa fa-chevron-right" aria-hidden="false">></span>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="showLoading&&!noData" class="load-box">
        <div class="sprite sprite-load load"></div>
      </div>
      <div v-if="noData" class="nodata-box">
        <span class="d-text-small d-text-grey">{{noData}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    },
    pages:{
      type: Array,
      // required: true
    },


    dataArr: {
      type: Array,
      required: true
    },
    initItem: {
      type: Object,
      default: null
    },
    keyValue: {
      // id字段
      type: String,
      default: "id"
    },
    displayValue: {
      // 展示字段
      type: String,
      default: "name"
    },
    placeholder: {
      // 未选择时的提示文字
      type: String,
      default: ""
    },
    selectedAlready: {
      type: String, // 选择的文字
      default: ""
    },
    reloadEverytime: {
      // 是否每次都重新请求数据
      type: Boolean,
      default: false
    },
    closeAllCombobox: {
      // 是否关闭所有下拉框
      type: Boolean,
      default: false
    },
    noData: {
      type: String,
      default: ""
    },
    idealHeight: {
      // 下拉框高度
      type: Number,
      default: 200
    }
  },
  watch: {
    dataArr(to, from) {
      this.showLoading = false;
    },
    closeAllCombobox(to, from) {
      if (to) {
        this.selectOpen = false;
      }
    }
  },
  data() {
    return {
      selectOpen: false,
      showLoading: false,
      btnOffsetLeft: 0,
      btnOffsetRight: 0,
      btnOffsetTop: 0,
      btnOffsetBottom: 0,
      touchmoveX: 0,
      touchmoveY: 0,
    };
  },
  computed: {
  },
  methods: {
    select(e,item) {
      console.log(item);
      this.$emit("select-page", item);
    },
    prevOrNext(n) {
      this.$emit("change-page", n);
    },

    clickSelectBox() {
      this.selectOpen = !this.selectOpen;
      if (this.selectOpen) {
        console.log("emit open-combobox");
        this.$emit("open-combobox");
      }
      if (
        this.selectOpen &&
        (0 == this.dataArr.length || this.reloadEverytime || this.noData)
      ) {
        // 获取下拉列表数据
        this.$emit("get-combobox-data");
        this.showLoading = true;
      }
    },
    touchstartItem(e, item) {
      item.touched = true;
      this.$forceUpdate();
      let elem = e.target;
      this.btnOffsetLeft = elem.offsetLeft;
      this.btnOffsetRight = this.btnOffsetLeft + elem.offsetWidth;
      this.btnOffsetTop = elem.getBoundingClientRect().top;
      this.btnOffsetBottom = this.btnOffsetTop + elem.offsetHeight;
      let t = e.touches[0];
      this.touchmoveX = t.clientX;
      this.touchmoveY = t.clientY;
    },
    touchmoveItem(e, item) {
      let t = e.touches[0];
      this.touchmoveX = t.clientX;
      this.touchmoveY = t.clientY;
    },
    touchendItem(e, item) {
      item.touched = false;
      this.$forceUpdate();
      if (!this.testTouchOut()) {
        this.$emit("select-item", item);
      }
    },
    testTouchOut() {
      if (
        this.touchmoveX > this.btnOffsetRight ||
        this.touchmoveX < this.btnOffsetLeft ||
        this.touchmoveY > this.btnOffsetBottom ||
        this.touchmoveY < this.btnOffsetTop
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style scoped>
.select-box-box {
  width: 300px;
  max-width: 100%;
  height: 44px;
  overflow: visible;
  position: relative;
  box-sizing: border-box;
}
.select-box {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border: 1px solid #ddd;
  border-radius: 23px;
  position: absolute;
  /*z-index: 1000;*/
}
.input-box {
  display: flex;
}
.select-box-input {
  flex: 1;
  height: 44px;
  font-size: 17px;
  line-height: 44px;
  padding: 0 5px 0 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.img-box {
  padding: 0 15px 0 11px;
}
.arrow-down {
  transform: rotate(180deg);
}
.drop-down-box {
  width: 100%;
  /*min-height: 90px;*/
  min-height: 80px;
  background-color: rgba(248, 248, 248, 1);
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: auto;
  /*position: relative;*/
  position: absolute;
  top: 50px;
  z-index: 1001;
  /* min-height: 120px; */
}
.drop-down-box .item-row-box {
  min-width: 100%;
  padding: 0 15px;
}
.touched-bg {
  background-color: rgba(241, 241, 241, 1);
}
.drop-down-box .item-row {
  height: 45px;
  padding: 0 5px;
  font-size: 17px;
  line-height: 44px;
  color: #222;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
}
/* .drop-down-box .item-row-box:last-child .item-row {
  border: none;
} */
.drop-down-box .load-box {
  position: absolute;
  top: 50%;
  /*top:80px;*/
  left: 50%;
  height: 20px;
  width: 20px;
  transform: translate(-50%, -50%);
}
.drop-down-box .load {
  animation: load 1s linear infinite;
}
.nodata-box {
  height: 22px;
  text-align: center;
  position: relative;
  top: 30px;
}
@keyframes load {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.pagesInner{
  float: right;
  /* margin-right: 10px; */
  margin: 10px 10px;
}
.page {
  list-style: none;
  display: inline-block;
  width: 20px;
  /* border: 1px solid #ccc; */
  text-align: center;
  border-radius: 4px;
}
.actived {
  border-color: #2d8cf0;
  background-color: #2d8cf0;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/select/combobox.vue